export const NAV_BAR_WIDTH_COMPACT = 56;
export const NAV_BAR_WIDTH_EXPANDED = 250;
export const ADMIN_NAV_WIDTH_EXPANDED = 200;
export const ADMIN_NAV_WIDTH_COMPACT = NAV_BAR_WIDTH_COMPACT;
